import { gql, useQuery } from '@apollo/client'
import PageComponent from 'components/Dashboard/PageComponent'
import { DashboardTitle } from '../DashboardTitleContext'
import RapidSessionList, { rapidSessionFragment } from './RapidSessionList'

const allRapidSessionsQuery = gql`
  query RapidSessions {
    rapidSessions(includeInactive: true) {
      ...RapidSessionListFragment
    }
  }

  ${rapidSessionFragment}
`

const RapidSessions: PageComponent = () => {
  const { loading, error, data } = useQuery(allRapidSessionsQuery)

  if (loading) return <p>Loading...</p>

  if (error) throw error

  return (
    <>
      <section className="section">
        <DashboardTitle title="Rapid Testing Sessions" />
      </section>

      <section className="section">
        <div className="container">
          <h3 className="subtitle is-5">All Sessions</h3>

          <RapidSessionList sessions={data.rapidSessions} />
        </div>
      </section>
    </>
  )
}

RapidSessions.displayName = 'Rapid Testing Sessions'
RapidSessions.path = '/rapid-testing/rapid-sessions'

export default RapidSessions
